export default __webpack_public_path__ + "static/media/trophy-icon.c540ecad.jpg";